module.exports = __webpack_public_path__ + "img/mr.54c8264c.svg";